const AWS = {
  Auth: {
    identityPoolRegion: 'us-east-1',
    userPoolId: 'us-east-1_wwQAY0sOF',
    userPoolWebClientId: '2eildooi8705m20gf5cl10riht',
    identityPoolId: 'us-east-1:8e208a06-1793-4984-bdb0-06fa2d5eee37',
    mandatorySignIn: false,
    authenticationFlowType: 'USER_PASSWORD_AUTH'
  },
  Storage: {
    bucket: 'mentor-fit',
    region: 'us-east-1',
    identityPoolId: 'us-east-1:8e208a06-1793-4984-bdb0-06fa2d5eee37'
  }
}

export default AWS



// WEBPACK FOOTER //
// ./src/aws-exports.js